import script from "./MyLitigesRetoursView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyLitigesRetoursView.vue?vue&type=script&setup=true&lang=ts"

import "./MyLitigesRetoursView.vue?vue&type=style&index=0&id=ddaed6da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddaed6da"]])

export default __exports__